import { z } from 'zod';
import { FlowBlockType } from '../flowDefinition/blocks/type.js';
export const FlowTestBlockerKindSchema = z.enum([
    'UnmockedUnsafeBlock',
    'UnreachableBlockReference',
    'DuplicateBlockId',
    'NoAssertions',
]);
export const FlowTestBlockerKind = FlowTestBlockerKindSchema.enum;
export const FlowTestBlockReferenceSourceSchema = z.enum(['Mock', 'ConfigMock', 'Assertion']);
export const FlowTestBlockReferenceSource = FlowTestBlockReferenceSourceSchema.enum;
const FlowTestPreflightBlockSchema = z.object({
    blockId: z.string(),
    blockName: z.string(),
    blockType: z.enum(FlowBlockType),
});
export const FlowTestBlockerSchema = z.discriminatedUnion('kind', [
    FlowTestPreflightBlockSchema.extend({
        kind: z.literal(FlowTestBlockerKind.UnmockedUnsafeBlock),
    }),
    /** The block is missing, disconnected, or inside an output-mocked sub-flow, so the reference cannot take effect. */
    z.object({
        kind: z.literal(FlowTestBlockerKind.UnreachableBlockReference),
        blockId: z.string(),
        referencedBy: FlowTestBlockReferenceSourceSchema,
    }),
    /** Cloned sub-flows can reuse an id, making every id-keyed mock, unlock, and assertion ambiguous. */
    z.object({
        kind: z.literal(FlowTestBlockerKind.DuplicateBlockId),
        blockId: z.string(),
        blockNames: z.array(z.string()),
    }),
    z.object({ kind: z.literal(FlowTestBlockerKind.NoAssertions) }),
]);
export const FlowTestPreEffectSchema = z.enum(['CommunicationWindowCheck']);
export const FlowTestPreEffect = FlowTestPreEffectSchema.enum;
export const FlowTestWarningKindSchema = z.enum([
    'TimeDependentBlock',
    'UnmockedStartEntityBlock',
    'LiveUnsafeBlock',
    'UnexercisedPreEffect',
    'AssertionPinsExactInstant',
]);
export const FlowTestWarningKind = FlowTestWarningKindSchema.enum;
export const FlowTestWarningSchema = z.discriminatedUnion('kind', [
    FlowTestPreflightBlockSchema.extend({
        kind: z.literal(FlowTestWarningKind.TimeDependentBlock),
    }),
    /** Pointing a case at a real seeded entity is a legitimate way to test, so this only warns. */
    FlowTestPreflightBlockSchema.extend({
        kind: z.literal(FlowTestWarningKind.UnmockedStartEntityBlock),
    }),
    FlowTestPreflightBlockSchema.extend({
        kind: z.literal(FlowTestWarningKind.LiveUnsafeBlock),
    }),
    /** Mocking a block's output also skips the checks it runs before its side effect. */
    FlowTestPreflightBlockSchema.extend({
        kind: z.literal(FlowTestWarningKind.UnexercisedPreEffect),
        preEffect: FlowTestPreEffectSchema,
    }),
    z.object({
        kind: z.literal(FlowTestWarningKind.AssertionPinsExactInstant),
        assertionName: z.string(),
        blockId: z.string(),
    }),
]);
/** Only blockers prevent a run. */
export const FlowTestPreflightSchema = z.object({
    blockers: z.array(FlowTestBlockerSchema),
    warnings: z.array(FlowTestWarningSchema),
});
//# sourceMappingURL=preflight.js.map